export const FILING_1120_DEADLINE = "2023-10-17 10:30:00:AM";

export const INKLE_TAX = "TAX";
export const INKLE_BOOKS = "BOOKS";
export const ALL = "ALL";
